export const urlApi = "https://educacionapi.azurewebsites.net/api";

export const obtenerRegionales = urlApi + "/ObtenerRegionales";
export const ConsultaSolicitudPorId = urlApi + "/ConsultaSolicitudPorId?Id=";
export const obtenerSolicitudesPorRegional =
  urlApi + "/ObtenerPorRegional?regional=";
export const ObtenerSolicitudes = urlApi + "/ObtenerSolicitudes";
export const ObtenerSolicitudesPorId = urlApi + "/ObtenerPorUsuario?idusuario=";
export const editarEstado = urlApi + "/ActualizaEstadoSolicitud?id=";
export const obtenerSolicitudesporId = urlApi + "/ObtenerSolicitudesporId?Id=";
export const ObtenerGestionPorSolicitud =
  urlApi + "/ObtenerGestionPorSolicitud?SolicitudId=";
export const obtenerUsuarios = urlApi + "/ObtenerUsuarios";
export const obtenerClasificacion = urlApi + "/ObtenerClasificacion";
export const obtenerTodosEstados = urlApi + "/EstadosParametros?TipoUsuario=0";
export const obtenerGestionPorSolicitud =
  urlApi + "/ObtenerGestionPorSolicitud?SolicitudId=";
export const obtenerModalidad = urlApi + "/ObtenerModalidad";
export const obtenerModular = urlApi + "/ObtenerModular";
export const estadoParametros = urlApi + "/EstadosParametros?TipoUsuario=0";
export const estadoParametrosUser = urlApi + "/EstadosParametros?TipoUsuario=";
export const obtenerSubEstado = urlApi + "/ObtenerSubEstado?IdEstado=";
export const obtenerSolicitudesEstado = urlApi + "/ObtenerSolicitudes?Estado=";
export const creaClasificacionComercial =
  urlApi + "/CreaClasificacionComercial";
export const estadosParametrosTipoUsuario =
  urlApi + "/EstadosParametros?TipoUsuario=";
export const creaGestion = urlApi + "/CreaGestion?FechaCreacion=";
export const creaModalidad = urlApi + "/CreaModalidad";
export const obtenerUsuarioEducacion = urlApi + "/ObtenerUsuarioEducacion";
export const creaRegional = urlApi + "/CreaRegional";
export const creaEstados = urlApi + "/CreaEstados";
export const crearSolicitudes = urlApi + "/CrearSolicitudes?&Regional=";
export const CreaSubEstados = urlApi + "/CreaSubEstados";
export const creaUsuario = urlApi + "/CreaUsuario";
export const actualizaUsuario = "/ActualizaUsuario?Id=";
export const guardaSinAdjunto = "/GuardaSinAdjunto?&Regional=";
export const gestionSinAdunto = "/CreaGestionSinAdjunto?FechaCreacion=";
